import { type TermLifeStepParams, loanSchema } from '@flows/configs/de/termLife/steps/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

export const loan = (params: TermLifeStepParams) => {
  const schema = loanSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_termLife:steps.loan.title',
        },
      },
      {
        type: 'choice',
        options:
          schema.shape.products.shape.mga_term_life_insurance_de.shape.configuration_parameters.shape.loan.options.map(
            (option) => ({
              value: option,
              label: {
                type: 'translatableText',
                translationKey: `sharedFlows_termLife:steps.loan.options.${option}`,
              },
            })
          ),
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('loan'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'insured_sum',
    subFlow: SubFlow.TermLife,
  } as const satisfies AnyStepConfiguration
}
